module.exports = __webpack_public_path__ + "img/zhinengbuhuo.ceb60ff5.png";